import {$, cnpj, InputType, phone, Schema} from 'simpli-web-sdk'
import {InfoCargaAdicional} from '@/model/resource/InfoCargaAdicional'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'

export default (model: InfoCargaAdicional): Schema => ({
    horaFunc: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('horaFunc'),
                    value: model.horaFunc || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    escopoAtendimento: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('escopoAtendimento'),
                    value: model.escopoAtendimento || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    ramoAtividade: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('ramoAtividade'),
                    value: model.ramoAtividade || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    gestorComercial: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('gestorComercial'),
                    value: model.gestorComercial || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    telefoneAdicional: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('telefoneAdicional'),
                    value: model.telefoneAdicional && phone(model.telefoneAdicional) || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    nomeFantasia: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('nomeFantasia'),
                    value: model.nomeFantasia || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    contato: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('contato'),
                    value: model.contato || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    observacao: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('observacao'),
                    value: model.observacao || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    segmento: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('segmento'),
                    value: model.segmento || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    tipoInstalacao: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('tipoInstalacao'),
                    value: model.tipoInstalacao || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    ocorrencia: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('ocorrencia'),
                    value: model.ocorrencia || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    ocorrenciaManutencao: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('ocorrenciaManutencao'),
                    value: model.ocorrenciaManutencao || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
})
